import { extendTheme } from '@chakra-ui/react';
import ButtonChakra from './Button';
import TabsChakra from './Tabs';

const theme = extendTheme({
  fonts: {
    heading: 'Ubuntu, Open Sans',
    body: 'Ubuntu, Open Sans',
  },
  colors: {
    brand: {
      primary: '#0093B2',
      secondary: '#10242A',
      fontColors: {
        primary: '#444e53',
        secondary: '#10242A',
        third: '#0093B2',
        select: '#7F8A8F',
        label: '#888888',
      },
      success: '#389F4D',
    },
  },
  components: {
    Button: ButtonChakra,
    Tabs: TabsChakra,
  },
});

export default theme;
